import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=5662ef32&scoped=true&"
import script from "./newHome.vue?vue&type=script&lang=js&"
export * from "./newHome.vue?vue&type=script&lang=js&"
import style0 from "./newHome.vue?vue&type=style&index=0&id=5662ef32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662ef32",
  null
  
)

export default component.exports